{
  "header": {
    "eyebrow": "Financiën",
    "title": "Checklist",
    "description": "Vóór de maandelijkse berekeningen: wat er de afgelopen twee maanden in CPMS en IAM is veranderd, en wat niet goed is ingericht."
  },
  "refresh": "Vernieuwen",
  "loading": "Checklist laden",
  "error": {
    "title": "Checklist kon niet worden geladen",
    "description": "De identiteitsdienst reageerde niet. Probeer het later opnieuw."
  },
  "noAccess": {
    "title": "Alleen domeintoegang",
    "description": "De checklist beslaat de hele vloot en is alleen beschikbaar voor gebruikers op domeinniveau."
  },
  "card": {
    "error": {
      "title": "Deze controle kon niet worden uitgevoerd",
      "description": "De dienst erachter reageerde niet. Vernieuw om het opnieuw te proberen."
    },
    "columns": {
      "time": "Tijd",
      "action": "Actie",
      "otherAction": "overig",
      "type": "Type",
      "kind": "Soort",
      "locationId": "Locatie-id",
      "partyId": "Id",
      "objectId": "Id",
      "description": "Omschrijving",
      "user": "Gebruiker",
      "station": "Laadstation",
      "model": "Model",
      "lastSeen": "Laatst gezien",
      "location": "Locatie",
      "address": "Adres",
      "split": "Verdeelafspraak",
      "problem": "Probleem",
      "figures": "Afwijking",
      "reason": "Probleem",
      "cpms": "Openen in CPMS",
      "checked": "Gecontroleerd",
      "chargingPoints": "Laadpunten",
      "owners": "Eigenaren en fees",
      "change": "Wijziging",
      "chargeCard": "Laadpas",
      "contractId": "Contract-id",
      "token": "Token",
      "status": "Status",
      "driver": "Bestuurder",
      "tenant": "Tenant",
      "client": "Klant",
      "dataset": "Administratie",
      "linkedTo": "Gekoppeld aan"
    },
    "openInCpms": "{{id}} openen in CPMS",
    "checkedBy": "Gecontroleerd door {{user}} op {{time}}",
    "tickRow": "Markeer {{row}} als gecontroleerd",
    "tickFailed": "Het vinkje kon niet worden opgeslagen. Probeer het opnieuw.",
    "change": {
      "created": "Nieuw",
      "modified": "Gewijzigd"
    },
    "dataset": {
      "billing": "Facturatie",
      "reimbursement": "Terugbetaling"
    },
    "notLinked": "Niet gekoppeld"
  },
  "checks": {
    "newLocations": {
      "title": "Nieuwe locaties",
      "description": "OCPI-locaties die de afgelopen twee maanden in CPMS zijn aangemaakt.",
      "count": "{{count}} locatie",
      "count_other": "{{count}} locaties",
      "empty": {
        "title": "Geen nieuwe locaties",
        "description": "Er is de afgelopen twee maanden geen OCPI-locatie aangemaakt."
      }
    },
    "newParties": {
      "title": "Nieuwe tenants en organisaties",
      "description": "Tenants en organisaties die de afgelopen twee maanden in IAM zijn aangemaakt.",
      "count": "{{count}} partij",
      "count_other": "{{count}} partijen",
      "kind": {
        "tenant": "Tenant",
        "organisation": "Organisatie"
      },
      "empty": {
        "title": "Geen nieuwe tenants of organisaties",
        "description": "Er is de afgelopen twee maanden niets aangemaakt in IAM."
      }
    },
    "chargeCards": {
      "title": "Nieuwe en gewijzigde laadpassen",
      "description": "Laadpassen die de afgelopen twee maanden in de MSP-gateway zijn aangemaakt of gewijzigd.",
      "count": "{{count}} laadpas",
      "count_other": "{{count}} laadpassen",
      "status": {
        "active": "Actief",
        "inactive": "Inactief"
      },
      "validUntil": "Geldig tot {{date}}",
      "empty": {
        "title": "Geen nieuwe of gewijzigde laadpassen",
        "description": "Er is de afgelopen twee maanden geen laadpas aangemaakt of gewijzigd."
      }
    },
    "drivers": {
      "title": "Nieuwe en gewijzigde bestuurders",
      "description": "Bestuurders die de afgelopen twee maanden in de MSP-gateway zijn aangemaakt of gewijzigd.",
      "count": "{{count}} bestuurder",
      "count_other": "{{count}} bestuurders",
      "empty": {
        "title": "Geen nieuwe of gewijzigde bestuurders",
        "description": "Er is de afgelopen twee maanden geen bestuurder aangemaakt of gewijzigd."
      }
    },
    "weFactClients": {
      "title": "Nieuwe en gewijzigde WeFact-klanten",
      "description": "Klanten die de afgelopen twee maanden in WeFact (facturatie en terugbetaling) zijn aangemaakt of gewijzigd.",
      "count": "{{count}} klant",
      "count_other": "{{count}} klanten",
      "empty": {
        "title": "Geen nieuwe of gewijzigde klanten",
        "description": "Er is de afgelopen twee maanden geen WeFact-klant aangemaakt of gewijzigd."
      }
    },
    "tariffChanges": {
      "title": "Locatie- en tariefwijzigingen",
      "description": "Wijzigingen, verplaatsingen en verwijderingen van OCPI-locaties en tarieven in CPMS in de afgelopen twee maanden.",
      "count": "{{count}} wijziging",
      "count_other": "{{count}} wijzigingen",
      "type": {
        "location": "Locatie",
        "tariff": "Tarief"
      },
      "empty": {
        "title": "Geen wijzigingen",
        "description": "Er is de afgelopen twee maanden geen locatie of tarief gewijzigd."
      }
    },
    "stationsWithoutLocation": {
      "title": "Laadstations zonder locatie",
      "description": "Stations in CPMS die aan geen enkele locatie zijn gekoppeld, zodat hun sessies nergens aan toegeschreven kunnen worden.",
      "count": "{{count}} station",
      "count_other": "{{count}} stations",
      "empty": {
        "title": "Elk station heeft een locatie",
        "description": "Hier is niets te doen."
      }
    },
    "locationsWithoutTariff": {
      "title": "Locaties zonder tarief",
      "description": "Locaties zonder tarief, of met een tarief dat CPMS niet meer kent, zodat er niets te verdelen of te vergoeden valt.",
      "count": "{{count}} locatie",
      "count_other": "{{count}} locaties",
      "reason": {
        "none": "Geen tarief",
        "unresolved": "Onbekend tarief"
      },
      "empty": {
        "title": "Elke locatie heeft een tarief",
        "description": "Hier is niets te doen."
      }
    },
    "splits": {
      "title": "Verdeelafspraken die niet meer kloppen",
      "description": "Verdeelafspraken waarvan de servicekosten en de aandelen van de partijen niet optellen tot de huidige CPMS-prijs van de locatie, of waarvan CPMS de locatie of het tarief niet meer kent. Bij elke keer laden live gecontroleerd.",
      "count": "{{count}} verdeelafspraak",
      "count_other": "{{count}} verdeelafspraken",
      "status": {
        "Unbalanced": "Telt niet op",
        "LocationMissing": "Locatie weg",
        "TariffMissing": "Geen tarief"
      },
      "figure": "{{component}}: prijs {{price}}, kosten {{fee}}, partijen {{allocated}}, over {{remaining}} {{unit}}",
      "components": {
        "energyPricePerKwh": "Energie",
        "chargingTimePricePerHour": "Laden",
        "parkingTimePricePerHour": "Parkeren",
        "flatFeePrice": "Starttarief"
      },
      "units": {
        "energyPricePerKwh": "€/kWh",
        "chargingTimePricePerHour": "€/u",
        "parkingTimePricePerHour": "€/u",
        "flatFeePrice": "€/sessie"
      },
      "empty": {
        "title": "Elke verdeelafspraak klopt",
        "description": "Hier is niets te doen."
      }
    },
    "billingFees": {
      "title": "Locaties met een billing fee-probleem",
      "description": "CPMS-locaties waarvan de eigenaren of de billing fee niet kloppen: een eigenaar zonder billing fee (eigen noch van de tenant), een fee van nul, geen eigenaar, meerdere eigenaren of geen laadpunten. Bij elke keer laden live gecontroleerd.",
      "count": "{{count}} locatie",
      "count_other": "{{count}} locaties",
      "problem": {
        "FeeMissing": "Geen billing fee",
        "FeeZero": "Fee is nul",
        "NoOwner": "Geen eigenaar",
        "MultipleOwners": "Meerdere eigenaren",
        "NoChargingPoints": "Geen laadpunten",
        "OwnersUnreadable": "Eigenaren onleesbaar"
      },
      "owner": {
        "own": "{{owner}}: {{price}} per laadpunt",
        "tenant": "{{owner}}: {{price}} per laadpunt, van tenant {{tenant}}",
        "none": "{{owner}}: geen billing fee"
      },
      "empty": {
        "title": "Elke locatie wordt gefactureerd",
        "description": "Hier is niets te doen."
      }
    }
  }
}
